import { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderSection from "../header/header.component";
import { Col, Row } from "react-bootstrap";
import { neturalBlack } from "../../constants/color";
import CustomerCard from "../customer-card/customer-card.component";
import PaymentDetail from "../payment-detail/payment-detail.component";
import BookingDetails from "../booking-details/booking-details.component";
import SalesServiceLsit from "../sales-service-list/sales-service-list.component";
import TransferInfo from "../transfer-info/transfer-info.component";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useState } from "react";
import {
  FETCH_ORDER_DETAILS,
  UPDATE_ORDER_STATUS,
} from "../../services/graphql/sales";
import { useLazyQuery, useMutation } from "@apollo/client";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";
import { useSelector } from "react-redux";
import UpdateOrderStatus from "../update-order-status-section/update-order-status-section.component";
import { ORDER_CONFIRM_MODAL_MESSAGE } from "../../constants/constant";
import GlobalModal from "../modal-popup/global-modal";
import CustomButton from "../button/button.component";

const SalesServiceDetail = () => {
  const { orderId } = useParams();
  const businesprofile = useSelector((state) => state.businesprofile);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [orderInfo, setOrderInfo] = useState({});
  const [paymentDetail, setPaymentDetail] = useState({});
  const [transferInfo, setTransferInfo] = useState(null);
  const [media, setMedia] = useState([]);
  const [address, setAddress] = useState({});
  const [inviteesName, setInviteesName] = useState([]);
  const [orderData, setOrderData] = useState({});
  const [orderStatus, setOrderStatus] = useState({});
  const [isVisibleConfirmModal, setIsVisibleConfirmModal] = useState(false);
  const [confirmModalContent, setConfirmModalContent] = useState({});
  let type = "";

  const getConfirmModalContent = (type) => {
    if (type === "Service") {
      return ORDER_CONFIRM_MODAL_MESSAGE.find(
        (item) => item.title === "Confirm Service Fulfillment"
      );
    } else {
      return ORDER_CONFIRM_MODAL_MESSAGE.find(
        (item) =>
          item.title === "Confirm Order Delivery" &&
          item.list[1].text.includes("delivery confirmation")
      );
    }
  };

  const [fetchOrderDetails, { loading: loadingOrderDetails }] = useLazyQuery(
    FETCH_ORDER_DETAILS,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (data && data.fetchOrderDetails) {
          let orderData = data.fetchOrderDetails;
          type = orderData.type;
          // console.log("Order details----------", orderData);
          setOrderData(orderData);
          setOrderStatus(orderData.status);
          setUserInfo(orderData.userInfo);
          setOrderInfo(orderData.orderInfo);
          setPaymentDetail(orderData.paymentSummary);
          setTransferInfo(orderData.transferInfo);
          setMedia(orderData.paymentSummary.itemInfo);
          setAddress(orderData.deliveryAddress);
          setInviteesName(orderData.inviteesInfo.invitees);

          const confirmModalContents = getConfirmModalContent(orderData.type);
          setConfirmModalContent(confirmModalContents);
        }
      },
      onError: (error) => {
        toast.error(error.message, {
          style: { width: "450px" },
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored ",
        });
        navigate("/sales");
      },
    }
  );

  const [updateOrderStatus, { loading: loadingUpdateOrderStatus }] =
    useMutation(UPDATE_ORDER_STATUS, {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (data && data.updateOrderStatus) {
          const responseOrder = data.updateOrderStatus;
          if (responseOrder.success) {
            setIsVisibleConfirmModal(false);
            getOrderDetails();
          } else {
            alert(responseOrder.message || "Something went wrong, please try again later!");
          }
        }
      },
      onError(error) {
        alert(error.message || "Something went wrong, please try again later!");
      },
    });

  const handleStatusChange = (e) => {
    setOrderStatus(e.target.value);
  };

  const handleConfirmClick = async () => {
    const updateOrderStatusInput = {
      orderId: orderId,
      newStatus: orderStatus,
    };
    await updateOrderStatus({
      variables: {
        updateOrderStatusInput,
      },
    });
  };

  const getOrderDetails = () => {
    fetchOrderDetails({
      variables: {
        transactionId: orderId,
        providerId: businesprofile._id,
      },
    });
  };

  useEffect(() => {
    getOrderDetails();
  }, [orderId]);
  return (
    <div
      className="main-div-right-section"
      style={{ backgroundColor: "white" }}
    >
      <Fragment>
        <HeaderSection currentTab={"Sales"} />
        <div className="second-section-style">
          {loadingOrderDetails ? (
            <div style={{ marginTop: "4%" }}>
              <LoadingSpinner overlay={false} />
            </div>
          ) : (
            <Fragment>
              <Row>
                <Col
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  style={{
                    paddingLeft: "0px",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "2%",
                  }}
                >
                  <label
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color: neturalBlack,
                    }}
                  >
                    Booking ID #{orderId}
                  </label>
                </Col>
                <Col lg="5" md="5" sm="5" xs="5" style={{ paddingLeft: 0 }}>
                  {/* Customer section for sales */}
                  <CustomerCard userInfo={userInfo} />
                  {/* Order detail section */}
                  <BookingDetails orderInfo={orderInfo} address={address} />
                  {/* Payment summary section */}
                  <PaymentDetail paymentDetail={paymentDetail} type={type} />
                  {/* Transfer info section - shows after order completion */}
                  <TransferInfo transferInfo={transferInfo} />
                  {/* Update order status section */}
                  <UpdateOrderStatus
                    type={type}
                    orderData={orderData}
                    handleStatusChange={handleStatusChange}
                    orderStatus={orderStatus}
                    handleButtonClick={() => setIsVisibleConfirmModal(true)}
                    loadingUpdateOrderStatus={loadingUpdateOrderStatus}
                    sectionTitle="Confirm Service Fulfillment"
                    sectionDescription="You are about to mark this service as Completed. Once confirmed:"
                  />
                </Col>
                <Col lg="1" md="1" sm="1" xs="1"></Col>
                <Col lg="6" md="6" sm="6" xs="6" style={{ paddingLeft: 0 }}>
                  <SalesServiceLsit
                    media={media}
                    spots={paymentDetail.bookedSpots}
                    inviteesName={inviteesName}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
        </div>
      </Fragment>
      {isVisibleConfirmModal && (
        <GlobalModal
          show={isVisibleConfirmModal}
          onClose={() => setIsVisibleConfirmModal(false)}
          showHeaderBorder={false}
          subtitle={confirmModalContent?.title || ""}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              marginBottom: "1%",
            }}
          >
            {confirmModalContent?.description}
          </p>
          {confirmModalContent?.list?.map((item) => (
            <label
              key={item.id}
              style={{
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "24px",
              }}
            >
              • {item.text}
            </label>
          ))}
          <CustomButton
            title={"Mark as Completed"}
            handleButtonClick={handleConfirmClick}
            customStyle={{ marginTop: "6%" }}
            loading={loadingUpdateOrderStatus}
          />
        </GlobalModal>
      )}
    </div>
  );
};

export default SalesServiceDetail;
